const paths = {
  dashboard: '/',
  createSurvey: '/survey-panel',
  questionPanel: '/survey-panel/questions/:token',
  reviewPanel: '/survey-panel/review/:token',
  surveyTemplatesPanel: '/survey-templates-panel/:audience/:anonimous/:shared',
  //surveyTemplatesPanelPreview: '/survey-templates-panel/preview/:id',
  invitesPanel: '/survey-panel/invites/:token',
  schedulePanel: '/survey-panel/schedule/:token',
  // categories: '/question-panel/categories',
  // subcategories: '/question-panel/sub-categories',
  question: '/super-admin/question',
  surveyView: '/survey-view/:aud/:token',
  surveyParticipants: '/survey-panel/participants/:token',
  resultsDash: '/survey-results',
  comments: '/survey-results/comments',
  login: '/login',
  loginRedirect: '/login-redirect',
  participantsReply: '/replies/:commentId',
  questiontag: '/super-admin/question-tags',
  superAdminRedirect: '/super-admin/redirect',
  pupilSurveys: '/pupil-surveys',
  pupilDashLogin: '/pupil-surveys/auth',
  qrCodeLogin: '/qr/:token',
  testWidgit: '/test-widgit/:aud/:token',
  checkinroot: '/checkin-surveys',
  checkinSurveys: '/checkin-surveys/checkin',
  checkinSurveysEdit: '/checkin-surveys/checkinEdit/:id',
  // Kiosk paths
  kioskRoot: '/kiosk',
  kioskSchool: '/kiosk/:schoolSlug',
  kioskUrn: '/kiosk/:schoolSlug/urn',
  kioskParentWelcome: '/kiosk/:schoolSlug/parent',
  kioskParentSearch: '/kiosk/:schoolSlug/parent/search',
  kioskParentVerify: '/kiosk/:schoolSlug/parent/verify',
  kioskParentSurveys: '/kiosk/:schoolSlug/parent/surveys',
  kioskParentThankYou: '/kiosk/:schoolSlug/parent/thank-you',
  kioskStudentWelcome: '/kiosk/:schoolSlug/student',
  kioskStudentSearch: '/kiosk/:schoolSlug/student/search',
  kioskStudentVerify: '/kiosk/:schoolSlug/student/verify',
  kioskStudentSurveys: '/kiosk/:schoolSlug/student/surveys',
  kioskStudentThankYou: '/kiosk/:schoolSlug/student/thank-you',
}

export default paths
